<template>
  <div class="contact"
       :class="langFlag ?'enPage':'chPage'">
    <div class="contact_iiner">
      <i class="contact_close "
         @click="closeContact()"></i>
      <p class="cont_p1 zwPage fontS">联系我们
        <!-- <i class="contact_close pcClose"
           @click="closeContact()"></i> -->
      </p>
      <p class="cont_p2 zwPage">请填写您的咨询信息，收到信息后我们会第一时间安排顾问与您联系。</p>
      <p class="cont_p1 ywPage fontS">Let’s Talk </p>
      <p class="cont_p2 ywPage">For new project inquiries, please tell me a little about
        yourself and your project and I’ll get back to you shortly</p>
      <div class="nueCont_itny">
        <div class="nueCont_form">
          <p class="cont_na ">{{langFlag ?'Name':'姓名' }}</p>
          <input type=" text"
                 value=""
                 placeholder=""
                 v-model="name"
                 class="cont_inp" />
        </div>
        <div class="nueCont_form">
          <p class="cont_na">{{langFlag ?'Email':'电子邮件' }}</p>
          <input type=" text"
                 value=""
                 placeholder=""
                 v-model="email"
                 class="cont_inp" />
        </div>
        <div class="nueCont_form">
          <p class="cont_na ">{{langFlag ?'Subject':'主题' }}</p>
          <input type=" text"
                 value=""
                 placeholder=""
                 v-model="theme"
                 class="cont_inp" />
        </div>
        <div class="nueCont_form">
          <p class="cont_na ">{{langFlag ?'Message':'信息' }}</p>
          <textarea type=" text"
                    value=""
                    placeholder=""
                    v-model="information"
                    class="cont_area"></textarea>
        </div>
        <div class="mut_bt">
          <button class="tjxx"
                  @click="sendMessage">{{langFlag ?'Submit':'提交' }}</button>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { isCardName, isEmailAvailable } from '@/untils/tool.js'
import { Toast } from 'vant'
import { mapMutations, mapGetters, mapState } from 'vuex'
export default {
  name: '',
  data() {
    return {
      mzname: '',
      mzaddress: '',
      mzemail: '',
      mztel: '',
      mzybCode: '',
      name: '',
      email: '',
      theme: '',
      information: '',
    }
  },
  watch: {},
  computed: {
    ...mapState(['langFlag', 'lang']),
  },
  methods: {
    closeContact() {
      this.$emit('closeContact', false)
    },
    // 联系我们
    sendMessage() {
      if (!isCardName(this.name)) {
        this.$toast('请输入正确的姓名')
        return false
      }
      if (!isEmailAvailable(this.email)) {
        this.$toast('请输入正确的电子邮箱')
        return false
      }
      if (this.theme.length == 0) {
        this.$toast('请输入主题')
        return false
      }
      if (this.information.length == 0) {
        this.$toast('请输入信息')
        return false
      }

      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'sendMessage',
        that.$qs.stringify({
          type: type,
          name: that.name,
          email: that.email,
          subject: that.theme,
          content: that.information,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            Toast('提交成功~')
            that.name = ''
            that.email = ''
            that.theme = ''
            that.information = ''
          }
        })
        .catch(function (error) {})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/contact.vue